import { AuditMatch } from '../../types';

export function MatchName(p: { match: AuditMatch }) {
  const audio = p.match.audio;
  const displayValue =
    (audio && 'id' in audio ? (audio as { id?: string }).id : undefined) ||
    audio?.customId ||
    audio?.title;

  return <span>{displayValue}</span>;
}
